import { createHash } from 'crypto';

const normalize = (value: unknown): unknown => {
    if (value === null || value === undefined) {
        return value;
    }

    if (Array.isArray(value)) {
        return value.map(item => normalize(item));
    }

    if (typeof value === 'object') {
        return Object.keys(value as Record<string, unknown>)
            .sort()
            .reduce<Record<string, unknown>>((acc, key) => {
                acc[key] = normalize((value as Record<string, unknown>)[key]);
                return acc;
            }, {});
    }

    return value;
};

export const createStableCacheKey = (namespace: string, payload: unknown): string => {
    const serializedPayload = JSON.stringify(normalize(payload));
    const payloadHash = createHash('sha256').update(serializedPayload).digest('hex');

    return `${namespace}:${payloadHash}`;
};
